import { render, staticRenderFns } from "./ExploreStatWidget.vue?vue&type=template&id=0ddee9be&"
import script from "./ExploreStatWidget.vue?vue&type=script&lang=js&"
export * from "./ExploreStatWidget.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports